(function () {

    'use strict';


    /**
     * @module servicesModal
     */
    var topServicesModal = {};
    
    /**
     * Initialise modal funtionality
     * 
     * @memberof module:servicesModal
     */
    topServicesModal.init = function() {
        var modals = document.querySelectorAll('.qld__modal');
        var modalUnderlay = document.querySelectorAll('.qld__modal__underlay');
        var modalBtn = document.querySelectorAll('.qld__open-modal');
        var getLocationBtn = document.querySelectorAll('.qld__geo-location__request');
        var locationDenyBtn = document.querySelectorAll('.qld__geo-location__deny ');

        if(modalBtn) {
            // loop over each button found that opens a modal and setup modals
            for (let i = 0; i < modalBtn.length; i++) {
                modalBtn[i].addEventListener('click', function() {
                    let modalOpenBtn = this;
                    let modalTarget = this.getAttribute('data-modaltarget');
                    let modalEl = document.querySelector(`#${modalTarget}`);

                    if(modalEl) {
                        let modalCloseBtn = modalEl ? modalEl.querySelector('.qld__modal__close') : null;
                        let modalDenyBtn = modalEl ? modalEl.querySelector('.qld__modal__deny') : null;
                        let modalAcceptBtn = modalEl ? modalEl.querySelector('.qld__modal__accept') : null;
                        // trap focus
                        // add all the elements inside modal that are focusable
                        let focusableElements = 'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])';
                        let firstFocusableElement = modalEl.querySelectorAll(focusableElements)[0]; // get first element to be focused inside modal
                        let focusableContent = modalEl.querySelectorAll(focusableElements);
                        let lastFocusableElement = focusableContent[focusableContent.length - 1]; // get last element to be focused inside modal

                        document.addEventListener('keydown', function(e) {
                            let isTabPressed = e.key === 'Tab' || e.keyCode === 9;

                            if (!isTabPressed) {
                                return;
                            }

                            if (e.shiftKey) { // if shift key pressed for shift + tab combination
                                if (document.activeElement === firstFocusableElement) {
                                    lastFocusableElement.focus(); // add focus for the last focusable element
                                    e.preventDefault();
                                }
                            } else { // if tab key is pressed
                                if (document.activeElement === lastFocusableElement) { // if focused has reached to last focusable element then focus first focusable element after pressing tab
                                    firstFocusableElement.focus(); // add focus for the first focusable element
                                    e.preventDefault();
                                }
                            }
                        });

                        modalEl.classList.add('active');
                        modalEl.focus();     
                        
                        // if modal is update-location then initialise userLocationFinder
                        if(modalEl.classList.contains('qld__update-location')) {
                            QLD.userLocationFinder.init();
                        }

                        if(modalCloseBtn) {
                            modalCloseBtn.addEventListener('click', function(e) {
                                modalEl.classList.remove('active');
                                modalOpenBtn.focus();
                            });
                        }

                        if(modalDenyBtn) {
                            modalDenyBtn.addEventListener('click', function(e) {
                                modalEl.classList.remove('active');
                                modalOpenBtn.focus();
                            });
                        }

                        if(modalAcceptBtn) {
                            modalAcceptBtn.addEventListener('click', function(e) {
                                modalEl.classList.remove('active');
                                modalOpenBtn.focus();
                            });
                        }
                    } else {
                        console.log(`Modal '#${modalTarget}' not found.`)
                    }
                });

                
            }
        }

        if(modalUnderlay) {
            for (let i = 0; i < modalUnderlay.length; i++) {
                modalUnderlay[i].addEventListener('click', function() {
                    this.parentNode.classList.remove('active');
                });
            }
        }
    
        if(getLocationBtn) {
            for (let i = 0; i < getLocationBtn.length; i++) {

                getLocationBtn[i].addEventListener('click', function() {
                    QLD.utils.geolocateUser();
                });
            }
        }
    
        if(locationDenyBtn) {
            for (let i = 0; i < locationDenyBtn.length; i++) {
                locationDenyBtn[i].addEventListener('click', function() {
                    QLD.utils.setLocalStorage('qld_geolocation', 'deny')
                });
            }
        }

        if(modals && QLD.utils.getLocalStorage('qld_geolocation') !== 'deny') {
            for (let i = 0; i < modals.length; i++) {
                if(modals[i].classList.contains('qld__services-modal')) {
                    var modalId = modals[i].id;
                    var modalToActivate = document.querySelector(`[data-modaltarget=${modalId}]`);

                    console.log(modalId);

                    if(!QLD.utils.getLocalStorage('qld_user_location')) {
                        if(modalToActivate) {
                            modalToActivate.click();
                        }
                    }
                }
            }
        }
    
    }
    
    QLD.topServicesModal = topServicesModal;

    window.addEventListener('DOMContentLoaded', function () {
        // QLD.topServicesModal.init();
    });
    
}());